import { getClerkInstance } from "@clerk/clerk-expo";
import { API_BASE_URL, HUB_BASE_URL } from "@constants/urls";
import { useAppStore } from "@hooks/useAppStore";
import axios, { type InternalAxiosRequestConfig } from "axios";

const getAuthToken = async (skipCache = false) => {
	const token = await getClerkInstance().session?.getToken({
		template: "jwt-with-user",
		skipCache,
	});
	return token;
};
const authorizationInterceptor = async (config: InternalAxiosRequestConfig) => {
	const token = await getAuthToken();
	if (token) {
		config.headers.Authorization = token;
	}

	return config;
};

const getTenantId = () => {
	const tenantId = useAppStore.getState().tenant.id;
	return tenantId;
};

const authAxios = axios.create();

export const hubAxios = axios.create();
hubAxios.defaults.baseURL = HUB_BASE_URL;
hubAxios.interceptors.request.use(authorizationInterceptor);

authAxios.interceptors.request.use(async (config) => {
	const token = await getAuthToken();

	config.headers.Authorization = token;
	config.headers.tenantid = getTenantId();
	return config;
});

// Session API (assessments/v1) client. Base URL is set on the instance and NO
// tenantid header is sent - tenantid triggers a CORS rejection on
// /assessments/v1, and the gateway derives the tenant from the jwt-with-user
// token instead.
export const apiAxios = axios.create({ baseURL: API_BASE_URL });

apiAxios.interceptors.request.use(async (config) => {
	const token = await getAuthToken(true);
	config.headers.Authorization = token;
	return config;
});

export default authAxios;
